import './component.scss'
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('newYearHolidayNotice', class extends Controller {
  static targets = ['dialog']

  connect () {
    this.openDialog()
    document.addEventListener('keydown', this.disableEscKey)
  }

  openDialog () {
    this.dialogTarget.showModal()
    this.dialogTarget.setAttribute('data-activate', 'true')
  }

  async closeDialog () {
    this.removeDisableEscKeyEvent()

    this.dialogTarget.setAttribute('data-activate', 'false')
    await this.wait(0.3)
    this.dialogTarget.close()
  }

  overlayClick (event) {
    if (event.target === event.currentTarget) {
      this.closeDialog()
    }
  }

  disableEscKey (event) {
    if (event.key === 'Escape') {
      event.preventDefault()
    }
  }

  removeDisableEscKeyEvent () {
    document.removeEventListener('keydown', this.disableEscKey)
  }

  wait (sec) {
    return new Promise((resolve) => {
      setTimeout(resolve, sec * 1000)
    })
  }
})
